"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatus = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var FormStatus = function (_a) {
    var video = _a.video, onChange = _a.onChange;
    function update() {
        var hidden = !video.hidden;
        onChange(!video.hidden);
        if (video.id) {
            ra_fetch_1.Fetcher.api('backend')
                .update('channels.tag.update', {
                channel_id: video.channel_id,
                id: video.channel_id,
                video_id: video.id,
                hidden: hidden ? 1 : 0,
            });
        }
    }
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-videos-form-status' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'storybook-videos-form-status-title' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Status wijzigen"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Span, { className: 'storybook-forms-status-label' }, "Publiek"),
                    react_1.default.createElement(storybook_1.Forms.Toggle, { value: !Boolean(video.hidden), onClick: update }))),
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'mt-4' }, "Zet de video op publiek om deze beschikbaar te maken op Eyecons.com en in je videowall.")));
};
exports.FormStatus = FormStatus;
exports.FormStatus.propTypes = {};
exports.FormStatus.defaultProps = {};
